import { get } from 'lodash';
import React from 'react';
import { AccessTime } from 'styled-icons/material/AccessTime';
import { Place } from 'styled-icons/material/Place';
import { Wrench } from 'styled-icons/fa-solid';

import { IJob } from '@src/features/job';
import { capitalizeFirstLetter } from 'src/helpers';
import { Flex, Text, TextBox, Box } from 'src/kit';

import { StyledJobCard } from '../atoms/StyledJobCard';

export const JobCard = React.memo(
  ({ job, onClick }: { job: IJob; onClick: () => void }) => (
    <StyledJobCard onClick={onClick}>
      <div className="cover-wrapper" style={{ background: job?.company?.color }}>
        <img src={job.company.cover_picture_url || job.company.cover} className="cover" alt={job.position_title} />
        <img className="logo" src={job.company.logo_url || job.company.logo} alt={job.position_title} />
      </div>
      <Flex height="calc(100% - 110px)" flexDirection="column" p={20} pb={30} flex={1}>
        <TextBox
          mt="auto"
          mb={18}
          color="blueGreyTwo"
          fontSize={14}
          fontWeight="normal"
          lineHeight={1}
          letterSpacing="1px"
          textAlign="left"
          textStyle="caps"
        >
          {job.is_anonymous && !job.candidate_is_trusted ? job.company_industry : job.company.name}
        </TextBox>
        <TextBox
          mb={18}
          title={job.position_title}
          textStyle="ellipsis"
          color="textPrimary"
          fontSize={16}
          fontWeight="bold"
          textAlign="left"
        >
          {capitalizeFirstLetter(job.position_title)}
        </TextBox>
        <Flex color="textSecondary">
          <Text mt="auto" fontSize={14} textStyle="ellipsis" mr={20}>
            <Box position="relative" style={{ bottom: 2 }} as={Wrench} size="12px" mr={'4px'} />
            {job.job_functions.join(', ')}
          </Text>
          {get(job, 'office.city') && (
            <Text flex="0 0 auto" mr={20}>
              <Box position="relative" style={{ bottom: 2 }} as={Place} size="14px" />
              {get(job, 'office.city')}
            </Text>
          )}
          <Text css={{ overflow: 'hidden', maxWidth: '33%' }} textStyle="ellipsis">
            <Box position="relative" style={{ bottom: 2 }} mr={5} as={AccessTime} size="14px" />
            {job.employment_type + (job.experiences.length > 0 ? ' | ' + job.experiences.join(', ') : '')}
          </Text>
        </Flex>
      </Flex>
    </StyledJobCard>
  ),
  (prevProps, nextProps) => {
    return prevProps.job?.id === nextProps.job?.id;
  }
);
